import { BrowserRouter } from 'react-router-dom';
import { AuthProvider, ThemeProvider, DeviceProvider } from '@/contexts';
import { ErrorBoundary } from '@/components/common/ErrorBoundary/ErrorBoundary';
import { AppRoutes } from '@/routes';

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <DeviceProvider>
            <ErrorBoundary>
              <AppRoutes />
            </ErrorBoundary>
          </DeviceProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
